module.exports = __webpack_public_path__ + "assets/img/btn-view-54417b56.png";